/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportPageImportRowView } from '../../models/api-response-import-page-import-row-view';

export interface ImportRows$Params {
  'x-api-requestId'?: string;
  reference: string;
  status?: Array<string>;
  page?: number;
  size?: number;
}

export function importRows(http: HttpClient, rootUrl: string, params: ImportRows$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportPageImportRowView>> {
  const rb = new RequestBuilder(rootUrl, importRows.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.path('reference', params.reference, {});
    rb.query('status', params.status, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportPageImportRowView>;
    })
  );
}

importRows.PATH = '/v1/api/ui/imports/{reference}/rows';
